
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft2 as ObiWindShaft2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-2.js';
 
 
 

 
 export const ObiWindShaft2 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-2',
   elementClass: ObiWindShaft2Element,
   events: {
     
   }
  });
 
 